<template>
	<div>
		<div style="padding-top: 4rem">
			<div class="">
				<div style="font-weight: 700" class="alert alert-warning text-center">
					<h4>YOU ARE SUBMITTING ANNUAL REPORT</h4>
				</div>
			</div>
			<form action="" @submit.prevent="handleFormSubmit">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-md-6">
								<div class="row mb-3">
									<label for="report_from" class="col-sm-4 col-form-label"
										>Report Period From:<span class="text-danger"
											>*</span
										></label
									>
									<div class="col-sm-8">
										<DateInput name="report_from" id="report_from" required />
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="row mb-3">
									<label for="report_to" class="col-sm-4 col-form-label"
										>Report Period To:<span class="text-danger">*</span></label
									>
									<div class="col-sm-8">
										<DateInput name="report_to" id="report_to" required />
									</div>
								</div>
							</div>
							<div class="col-md-6" style="display: none">
								<div class="row mb-3">
									<label
										for="annual_report_type"
										class="col-sm-4 col-form-label"
										>Annual Report Type:<span class="text-danger"
											>*</span
										></label
									>
									<div class="col-sm-8">
										<select
											v-model="form.annual_report_type"
											name="annual_report_type"
											id="annual_report_type"
											class="form-select"
											required
											style="
												padding: 0.625rem 3.5625rem 0.625rem 1.1875rem;
												border: 1px solid #ced4da;
												border-radius: 0.25rem;
											"
										>
											<option value="">--select--</option>
											<option value="general_election">General Election</option>
											<option value="by_election">Bye-Election</option>
											<option value="off_cycle_election">
												Off-Cycle Election
											</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="row mb-3">
									<label
										for="cash_at_hand_start"
										class="col-sm-4 col-form-label"
										>Cash at hand at start of period:<span class="text-danger"
											>*</span
										></label
									>
									<div class="col-sm-8">
										<input
											v-model="form.cash_at_hand_start"
											name="cash_at_hand_start"
											id="cash_at_hand_start"
											type="text"
											class="form-control"
											placeholder="Eg. 5,000,000"
											required
										/>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="row mb-3">
									<label for="cash_at_hand_end" class="col-sm-4 col-form-label"
										>Cash at hand at close of reporting period:<span
											class="text-danger"
											>*</span
										></label
									>
									<div class="col-sm-8">
										<input
											v-model="form.cash_at_hand_end"
											name="cash_at_hand_end"
											id="cash_at_hand_end"
											type="text"
											class="form-control"
											placeholder="Eg. 5,000,000"
											required
										/>
									</div>
								</div>
							</div>

							<div class="col-md-6">
								<div class="row mb-3">
									<label for="approval_document" class="col-sm-4 col-form-label"
										>Upload Approval Document:<span class="text-danger"
											>*</span
										></label
									>
									<div class="col-sm-8">
										<input
											@change="getFiles()"
											name="approval_document"
											id="approval_document"
											ref="approval_document"
											type="file"
											class="form-control"
											required
										/>
									</div>
								</div>
							</div>

							<div class="col-md-6" style="display: none">
								<div class="row mb-3">
									<label for="approved_by" class="col-sm-4 col-form-label"
										>Chairman Name:<span class="text-danger">*</span></label
									>
									<div class="col-sm-8">
										<input
											v-model="form.approved_by"
											name="approved_by"
											id="approved_by"
											type="text"
											class="form-control"
										/>
									</div>
								</div>
							</div>
							<div class="col-md-6" style="display: none">
								<div class="row mb-3">
									<label for="prepared_by" class="col-sm-4 col-form-label"
										>Financial Secretary Name:<span class="text-danger"
											>*</span
										></label
									>
									<div class="col-sm-8">
										<input
											v-model="form.prepared_by"
											name="prepared_by"
											id="prepared_by"
											type="text"
											class="form-control"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card-footer" align="right">
						<router-link
							to="/forms/annual-report"
							tag="button"
							class="btn btn-secondary me-2"
							>Back to List</router-link
						>
						<LoadingButton class="btn btn-info">Continue</LoadingButton>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import { mapActions } from "vuex";
import { EventBus } from "@/utils/event_bus.js";
import DateInput from "@/components/DateInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";

export default {
	components: {
		LoadingButton,
		DateInput,
	},
	data() {
		return {
			form: {
				report_from: "",
				report_to: "",
				approval_document: "",
				annual_report_type: "general_election",
				cash_at_hand_start: "",
				cash_at_hand_end: "",
				approved_by: "",
				prepared_by: "",
			},
		};
	},
	methods: {
		...mapActions({
			addBaseReport: "form_ec16c/addBaseReport",
		}),

		async handleFormSubmit() {
			let formData = new FormData();

			formData.append("approval_document", this.form.approval_document);
			formData.append("report_from", this.form.report_from);
			formData.append("report_to", this.form.report_to);
			formData.append("approved_by", this.form.approved_by);
			formData.append("annual_report_type", this.form.annual_report_type);
			formData.append("cash_at_hand_start", this.form.cash_at_hand_start);
			formData.append("cash_at_hand_end", this.form.cash_at_hand_end);
			formData.append("prepared_by", this.form.prepared_by);

			await this.addBaseReport(formData).then((res) => {
				if (res.status_code == 201) {
					this.$router.push(`/forms/${res.data.id}/annual-report`);
				}
			});
		},

		getFiles() {
			this.form.approval_document = this.$refs.approval_document.files[0];
		},

		clearFormInput() {
			this.form.amount_received = [];
			this.item_type = "";

			this.months.forEach(
				(month, index) =>
					(document.getElementById(`${month.name}_${index}`).value = "")
			);
		},
		setDateInput(payload) {
			this.form[payload.inputId] = payload.value;
		},
	},
	mounted() {
		EventBus.$on("date-input", this.setDateInput);
	},
};
</script>
